// extracted by mini-css-extract-plugin
export default {"show-more-link":"ShowMoreLink_show-more-link__dVES+","bounceAnimation":"ShowMoreLink_bounceAnimation__TI6y4"};